import axios from "../api/axiosInstance";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";

export default function VerifyEmail() {
  const location = useLocation();
  const [status, setStatus] = useState("pending");

  // Utility to get query params
  function getQueryParam(param) {
    return new URLSearchParams(location.search).get(param);
  }

useEffect(() => {
  const token = getQueryParam("token");
  if (token) {
    // Make the network call with POST body
    axios.post('/v1/auth/verify-email', { token })
      .then((res) => res.data)
      .then((data) => {
        if (data.status === "success") {
          setStatus("success");

          toast.success("Email verified successfully! Navigating to login page.");
            setTimeout(() => {
                window.location.href = "/login"; // Redirect to login page after success
            }, 2000);
        } else {
          setStatus("error");
        }
      })
      .catch(() => setStatus("error"));
  } else {
    setStatus("missing");
  }
}, [location.search]);

  return (
    <div style={{ padding: "2rem", textAlign: "center" }}>
      <h1>Email Verification</h1>
      {status === "pending" && <p>Verifying your email...</p>}
      {status === "success" && (
        <p>Your email has been successfully verified! You may now log in.</p>
      )}
      {status === "error" && (
        <p>
          There was a problem verifying your email. Please try again or contact support.
        </p>
      )}
      {status === "missing" && (
        <p>
          Verification token is missing. Please check your link or contact support.
        </p>
      )}
    </div>
  );
}
